import { render, staticRenderFns } from "./workerCard.vue?vue&type=template&id=e0d6ae8a&scoped=true&"
import script from "./workerCard.vue?vue&type=script&lang=js&"
export * from "./workerCard.vue?vue&type=script&lang=js&"
import style0 from "./workerCard.vue?vue&type=style&index=0&id=e0d6ae8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d6ae8a",
  null
  
)

export default component.exports